import { useTranslation } from 'react-i18next';

import { Card } from '@components/card';
import { CTA } from '@components/cta';
import { Typography } from '@components/typography';

import { isMobileDevice } from '@globalUtils/environment';

import AICopilotImg from '@assets/aiCopilot.avif';
import AIFixImg from '@assets/aiFix.avif';
import AIQuickImg from '@assets/aiQuick.avif';

export function IntroAIFeaturesSection() {
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col items-center gap-[5vh] lg:gap-[10vh]">
      <div className="flex w-full flex-wrap lg:flex-nowrap justify-between items-center gap-0">
        <div className="w-full lg:w-[55%] lg:pr-12 shrink-0 flex flex-col items-center lg:items-start">
          <Typography className="w-full items-start" variant="header" align="start">
            {t('intro-aifeatures-section-main')}
          </Typography>
          <Typography className="w-full items-start! mt-4" variant="base" align="start">
            {t('intro-aifeatures-section-secondary')}
          </Typography>
          {!isMobileDevice() && <CTA className="mt-[3vh] lg:mt-[5vh]" data-id="boton-8" />}
        </div>

        <div className="w-full flex flex-col">
          <div className="border-1 border-gray-100 w-full lg:grow flex flex-col items-center lg:items-start rounded-[12px] overflow-hidden shadow-lg p-2">
            <div
              className="p-0 rounded-[8px] w-full"
              style={{
                aspectRatio: 1920 / 1080,
                objectPosition: 'center center',
              }}
            >
              <div className="wistia_responsive_padding w-full h-full" style={{ position: 'relative' }}>
                <div
                  className="wistia_responsive_wrapper"
                  style={{ height: '100%', left: 0, position: 'absolute', top: 0, width: '100%' }}
                >
                  <iframe
                    src="https://fast.wistia.net/embed/iframe/ls2vvcq6z4?web_component=true&seo=true"
                    title="segundo_sc Video"
                    allow="autoplay; fullscreen"
                    frameBorder="0"
                    scrolling="no"
                    className="wistia_embed"
                    name="wistia_embed"
                    width="100%"
                    height="100%"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
          {isMobileDevice() && (
            <div className="w-full flex justify-center">
              <CTA className="mt-[5vh] lg:mt-[5vh]" data-id="boton-9" />
            </div>
          )}
        </div>
      </div>
      <div className="flex w-full justify-between gap-8 lg:gap-4 flex-wrap lg:flex-nowrap">
        <Card
          imagePosition="top"
          title={t('intro-aifeatures-card-title-1')}
          description={t('intro-aifeatures-card-description-1')}
          image={AIQuickImg}
        />
        <Card
          title={t('intro-aifeatures-card-title-2')}
          description={t('intro-aifeatures-card-description-2')}
          image={AIFixImg}
        />
        <Card
          imagePosition="top"
          title={t('intro-aifeatures-card-title-3')}
          description={t('intro-aifeatures-card-description-3')}
          image={AICopilotImg}
        />
      </div>
    </div>
  );
}
